import { put, takeLatest } from "redux-saga/effects";
import { postSignatureApi } from "store/api/signtureApi";
import { SIGNATURE_ACTION } from "../../actions/SignatureAction/actionTypes";

import * as globalAction from "../../actions/GlobalAction";

function* showMessage(isError, message) {
	const alert = { isError: isError, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* postSignature(action) {
	yield put(globalAction.openLoadingPage());
	const { signature, onSuccess } = action.params;
	const data = {
		data: signature
	};
	const res = yield postSignatureApi(data);
	try {
		if (res?.code === 0) {
			onSuccess();
			yield showMessage(false, res?.message);
		} else {
			yield showMessage(true, res?.message);
		}
	} catch (e) {
		console.log(e);
	} finally {
		yield put(globalAction.closeLoadingPage());
	}
}

function* postSignatureSaga() {
	yield takeLatest(SIGNATURE_ACTION, postSignature);
}

export default postSignatureSaga;
